import BaseButton from 'components/atoms/baseButton';
import Section from 'components/molecules/section';

import DraggableModal from '../draggableModal';
import s from './styles.module.scss';
import { formSections } from './form-sections';
import { useNote } from './use-note';

import type { FC } from 'react';

interface CkdCcmClinicalModalProps {
  patientGuid: string;
  open: boolean;
  toggleOpen: () => void;
  onSubmit: (values: string) => void;
}

const CkdCcmClinicalModal: FC<CkdCcmClinicalModalProps> = ({
  patientGuid,
  open,
  toggleOpen,
  onSubmit,
}) => {
  if (!open) return null;

  const {
    currentStep,
    goToNextStep,
    goToPrevStep,
    setValue,
    errorSections,
    values,
    submit,
  } = useNote({
    patientGuid,
    onSubmit,
    toggleOpen,
  });

  return (
    <DraggableModal
      isOpen={open}
      toggle={toggleOpen}
      title="CKD Assessment - SignalCCM"
      subTitle={`${formSections[currentStep].title} - ${currentStep + 1} of ${
        formSections.length
      }`}
      footerClassName={s['footer-wrapper']}
      footer={
        <>
          <div>
            {currentStep === formSections.length - 1 &&
              errorSections.length > 0 && (
                <p className={s['error-fields']} data-cy="modal-error">
                  Missing fields in section(s): {errorSections.join(', ')}{' '}
                </p>
              )}
            {currentStep !== 0 && (
              <BaseButton
                onClick={goToPrevStep}
                label="< Back"
                type="secondary"
                dataCy="back-btn"
              />
            )}
            {currentStep === formSections.length - 1 ? (
              <>
                <BaseButton
                  disabled={Boolean(errorSections.length)}
                  onClick={submit}
                  label="Submit"
                />
              </>
            ) : (
              <BaseButton
                onClick={goToNextStep}
                label="Forward >"
                data-cy="forward-btn"
                type="secondary"
              />
            )}
          </div>
        </>
      }
    >
      <div className="narrative-popup">
        <Section
          forms={formSections[currentStep].forms}
          setValue={setValue}
          values={values}
          canEditPage
        />
      </div>
    </DraggableModal>
  );
};
export default CkdCcmClinicalModal;
